// extracted by mini-css-extract-plugin
export default {"container":"player_container__drdNm","title":"player_title__P-hvG","player":"player_player__X9mr8","poster":"player_poster__UOd+U"};